import { render, staticRenderFns } from "./user-list.html?vue&type=template&id=0bc5ab5b&scoped=true&external"
import script from "./user-list.js?vue&type=script&lang=js&external"
export * from "./user-list.js?vue&type=script&lang=js&external"
import style0 from "./user-list.scss?vue&type=style&index=0&id=0bc5ab5b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc5ab5b",
  null
  
)

export default component.exports